export enum QuestionSortOrder {
  Standard = 'standard',
  AverageAsc = 'avg asc',
  AverageDesc = 'avg desc'
}
